import onetime from "@-/com.npmjs.onetime";

import { graphemeMeaningImageList } from "#grapheme-meaning-image-assets-generated";
import type { GraphemeMeaningImageEntry } from "#types";

export const getGraphemeMeaningImageList = onetime(
  (): readonly GraphemeMeaningImageEntry[] => graphemeMeaningImageList,
);

const getGraphemeMeaningImageMap = onetime(() => {
  const graphemeMeaningImageMap = new Map<string, string>();
  for (const entry of getGraphemeMeaningImageList()) {
    if (!graphemeMeaningImageMap.has(entry.character)) {
      graphemeMeaningImageMap.set(entry.character, entry.urlPath);
    }
  }
  return graphemeMeaningImageMap;
});

export function getGraphemeMeaningImageUrlPath(character: string): string | null {
  return getGraphemeMeaningImageMap().get(character) ?? null;
}
